import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { useLadderDetail } from "../hooks/queries/useLadder";
import LadderStandings from "../components/players/LadderStandings";
import { Icon } from "../components/common/Icon";
import { getLoggedUser, isAdmin } from "../util/SecurityUtils";

function LadderDetail() {
  const { id } = useParams();
  const ladderId = Number(id);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { data: ladder, isLoading } = useLadderDetail(ladderId);

  if (isLoading || !ladder) return null;

  const loggedUser = getLoggedUser();
  const canManage = isAdmin() || (loggedUser?.id != null && loggedUser.id === ladder.ownerUserId);
  const displayName = i18n.language === "cs" ? ladder.name : ladder.nameEn;

  return (
    <div className="base-container">
      <div className="table-header header">
        <span className="table-title">{displayName}</span>
        {canManage ? (
          <Button
            variant="outline-light"
            size="sm"
            onClick={() => navigate(`/ladders/${ladderId}/settings`)}
            className="table-button table-button-icon"
            aria-label={t("ladderSettings")}
            title={t("ladderSettings")}
          >
            <Icon name="Gear" />
          </Button>
        ) : null}
      </div>
      <div className="content">
        <LadderStandings ladderId={ladderId} />
      </div>
    </div>
  );
}

export default LadderDetail;
